<template>
  <v-select
    label='Position '
    class="white"
    :items="data"
    item-text="name"
    item-value="id"
    v-model="inputVal"
    :loading="api.isLoading"
  ></v-select>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["value"],
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    code: null,
    item: null,
  }),
  created() {
    //BOC:[api]
    this.api.method = "get";

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.data = resp;
    };
    //EOC
  },
  computed: {
    ...mapState({
      school: (state) => state.school.data,
    }),
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    fetch() {
      this.api.url =`${this.$api.servers.sso}/api/v1/en/data/position/`
      this.$api.fetch(this.api);
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
